<template>
  <div class="features-studio" dir="rtl">
    <div class="features-studio__grid">
      <div class="features-studio__main">
        <div v-if="!hasFeatures" class="features-empty">
          ویژگی ندارد
        </div>

        <div
            class="feature-group"
            v-for="(featureGroup, group) in sortedFeatures"
            :key="group">
          <div class="feature-group__head">
            <button
                type="button"
                class="feature-group__toggle"
                v-b-toggle="`feature-group-${convertGroupNameUsableForCollapse(group)}`">
              <span class="feature-group__title">{{ group }}</span>
              <b-icon icon="chevron-down" class="feature-group__chevron"/>
            </button>

            <button
                type="button"
                class="feature-group__edit"
                v-b-modal="`feature-category-${convertGroupNameUsableForCollapse(group)}`">
              <b-icon-pen-fill/>
            </button>

            <b-modal :id="`feature-category-${convertGroupNameUsableForCollapse(group)}`" hide-footer>
              <div class="text-right">
                <feature-category-manager
                    @changeCategories="refreshComponent"
                    :product="product"
                    :feature-category="group"/>
              </div>
            </b-modal>
          </div>

          <b-modal id="product-variation-image-modal" hide-footer>
            <div class="text-right" dir="rtl">
              <p class="my-4">
                اشتراک استفاده شما از متغییر محصول به پایان رسیده است جهت تمدید بر روی دکمه زیر کلیک کنید.
              </p>
              <div class="text-center">
                <button class="btn btn-primary w-75 mx-auto" type="button">خرید</button>
              </div>
            </div>
          </b-modal>

          <b-collapse
              :id="`feature-group-${convertGroupNameUsableForCollapse(group)}`"
              visible
              class="feature-group__body">
            <div
                class="feature-group__items"
                :class="{ 'feature-group__items--square': !(feature.variation == 1 && feature.sub_product == 1) }"
                v-for="(feature, featureIndex) in featureGroup"
                :key="feature.id || featureIndex">
              <template v-if="feature.variation == 1 && feature.sub_product == 1">
                <product-feature-item
                    :product="product"
                    :productFeature="feature"
                    v-if="checkServiceIsExpire('is_product_variation_module_expire')"/>
                <img
                    v-else
                    src="../../../../../../public/product-variation.jpg"
                    alt="product-variation"
                    v-b-modal="`product-variation-image-modal`"
                    class="feature-group__upsell">
              </template>
              <template v-else>
                <product-feature-item
                    class="feature-card--square"
                    :product="product"
                    :productFeature="feature"/>
              </template>
            </div>
          </b-collapse>
        </div>
      </div>

      <aside class="features-studio__side">
        <div class="features-search-card">
          <div class="features-search-card__head">
            <div>
              <h3 class="features-search-card__title">افزودن ویژگی</h3>
              <p class="features-search-card__hint">جستجو و انتخاب از لیست ویژگی‌ها</p>
            </div>
            <button type="button" class="features-search-card__add" v-b-modal.create-product-feature title="ساخت ویژگی">
              <b-icon icon="plus"/>
            </button>
          </div>
          <feature-search
              ref="featureSearch"
              @selectedFeature="addFeature"
              @editFeature="openEditFeature"/>
        </div>
      </aside>
    </div>

    <b-modal
        id="create-product-feature"
        title="افزودن ویژگی محصول"
        size="lg"
        hide-footer
        centered>
      <div class="features-create-modal" dir="rtl">
        <quick-feature-create
            :key="`create-${featureFormKey}`"
            mode="create"
            @created="onFeatureCreated"/>
      </div>
    </b-modal>

    <b-modal
        id="edit-product-feature"
        title="ویرایش ویژگی محصول"
        size="lg"
        hide-footer
        centered
        @hidden="editingFeatureId = null">
      <div class="features-create-modal" dir="rtl">
        <quick-feature-create
            v-if="editingFeatureId"
            :key="`edit-${editingFeatureId}`"
            mode="edit"
            :feature-id="editingFeatureId"
            @created="onFeatureUpdated"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import FeatureSearch from "../../product/productFeatureComponents/FeatureSearch.vue";
import ProductFeatureItem from "../../product/productFeatureComponents/ProductFeatureItem.vue";
import FeatureCategoryManager from "../../product/productFeatureComponents/FeatureCategoryManager.vue";
import QuickFeatureCreate from "../../product/QuickFeatureCreate.vue";
import {addFeatureToProduct, removeChildFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {baseFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {checkServiceIsExpire} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/SiteServiceManager";

export default {
  name: "FeaturesManager",
  components: {QuickFeatureCreate, FeatureCategoryManager, FeatureSearch, ProductFeatureItem},
  props: {
    features: {},
    product: {},
  },
  data() {
    return {
      baseFeature,
      editingFeatureId: null,
      featureFormKey: 0,
    };
  },
  computed: {
    removeChildFeature,
    hasFeatures() {
      return Array.isArray(this.features) && this.features.length > 0
    },
    featureCategories() {
      let categories = []


      this.product.features.forEach((item) => {

        categories.push(item.extra)

      })

      return categories

    },
    sortedFeatures() {
      let features = this.features;


      features = removeChildFeature(features)

      // sort features base on item_order
      features = features.sort((a, b) => b.extra.item_order - a.extra.item_order);

      // group features base on category
      let featureGroup = features.reduce((acc, item) => {
        const category = item.extra.category;

        if (!acc[category]) {
          acc[category] = [];
        }

        acc[category].push(item);

        return acc;
      }, {});


      // add category info to each group
      let allFeatureCategories = this.featureCategories

      allFeatureCategories.sort((a, b) => b.category_order - a.category_order);
      let sortedFeatureGroup = {};
      for (let i = 0; i < allFeatureCategories.length; i++) {
        let category = allFeatureCategories[i].category;
        sortedFeatureGroup[category] = featureGroup[category];
      }

      // remove empty groups
      sortedFeatureGroup = this.removeEmptyGroups(sortedFeatureGroup)

      return this.groupByType(sortedFeatureGroup)
    },
  },
  methods: {
    checkServiceIsExpire,
    addFeatureToProduct,
    groupByType(features) {
      Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        let checkboxGroup = features[group].reduce((acc, item) => {
          if (item.feature.type === "checkbox") {
            let checkboxGroupName = item.extra.group
            if (!acc[checkboxGroupName]) {
              acc[checkboxGroupName] = [];
            }
            acc[checkboxGroupName].push(item);
          }
          return acc;
        }, {})
        let unCheckboxGroup = features[group].filter(item => item.feature.type !== "checkbox")
        features[group] = []
        Object.entries({...checkboxGroup, ...unCheckboxGroup}).forEach(newGenFeature => {
          let item = newGenFeature[1];
          if (Array.isArray(item)) {
            features[group].push({
              items: item,
              extra: item[0].extra
            })
          } else {
            features[group].push(item)
          }
        })
        features[group].sort((a, b) => b.extra.item_order - a.extra.item_order)

      })


      let result = {}
      // set order of checkbox group to correct order
      Object.entries(features).forEach(reshapeFeature => {
        let group = reshapeFeature[0]
        let items = reshapeFeature[1]
        result[group] = []
        items.forEach(item => {
          if (item.items != undefined) {
            result[group].push(item.items)
          } else {
            result[group].push(item)
          }
        })
      })
      return result
    },
    removeEmptyGroups(features) {
      let result = {}

      Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        if (items != undefined && items.length > 0) {
          result[group] = items
        }
      })

      return result

    },
    addFeature(feature) {
      this.addFeatureToProduct(feature, this.product)
      toast("با موفقیت اضافه شد", "با موفقیت اضافه شد")
    },
    convertGroupNameUsableForCollapse(group) {
      return group.replaceAll(' ', '-')
    },
    refreshComponent() {
      this.$forceUpdate()
    },
    async onFeatureCreated() {
      this.featureFormKey += 1
      await this.$store.dispatch('Feature/getFeatures')
      if (this.$refs.featureSearch && this.$refs.featureSearch.refreshFeatures) {
        await this.$refs.featureSearch.refreshFeatures()
      }
      this.$bvModal.hide('create-product-feature')
    },
    openEditFeature(feature) {
      this.editingFeatureId = feature.id
      this.$nextTick(() => {
        this.$bvModal.show('edit-product-feature')
      })
    },
    async onFeatureUpdated() {
      await this.$store.dispatch('Feature/getFeatures')
      if (this.$refs.featureSearch && this.$refs.featureSearch.refreshFeatures) {
        await this.$refs.featureSearch.refreshFeatures()
      }
      this.$bvModal.hide('edit-product-feature')
      this.editingFeatureId = null
    }
  }
};
</script>

<style scoped>
.features-studio {
  --ink: #1e1e1e;
  --ink-soft: #424242;
  --muted: #6b6b6b;
  --line: rgba(30, 30, 30, 0.1);
  --dash-primary: var(--primary, #eb3d60);
  --dash-primary-soft: rgba(235, 61, 96, 0.12);
}

.features-studio__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(240px, 300px);
  gap: 1rem;
  align-items: start;
}

.features-studio__main,
.features-studio__side {
  min-width: 0;
}

.features-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 1.25rem;
  border-radius: 16px;
  border: 1px dashed rgba(30, 30, 30, 0.18);
  background: #f7f7f8;
  color: var(--muted);
  font-size: 1rem;
  font-weight: 700;
}

.feature-group {
  margin-bottom: 0.85rem;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.04);
}

.feature-group__head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem;
  background: linear-gradient(120deg, rgba(235, 61, 96, 0.08), transparent 55%), #fafafa;
  border-bottom: 1px solid var(--line);
}

.feature-group__toggle {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.7rem 0.9rem;
  border: 0;
  border-radius: 12px;
  background: #fff;
  color: var(--ink);
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 1px 0 rgba(30, 30, 30, 0.04);
}

.feature-group__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feature-group__chevron {
  color: var(--muted);
  flex: 0 0 auto;
}

.feature-group__edit {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  color: var(--dash-primary);
  cursor: pointer;
  flex: 0 0 auto;
}

.feature-group__edit:hover {
  background: var(--dash-primary-soft);
}

.feature-group__body {
  padding: 0.75rem;
  background: #f7f7f8;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.feature-group__items {
  min-width: 0;
  grid-column: 1 / -1;
}

.feature-group__items--square >>> .feature-card {
  width: 100%;
}

.feature-group__items--square >>> .feature-card__grid {
  grid-template-columns: minmax(140px, 200px) minmax(0, 1fr);
}

.feature-group__items--square >>> .feature-card__image-wrap {
  min-height: 168px;
  max-height: none;
  aspect-ratio: auto;
}

.feature-group__items + .feature-group__items {
  margin-top: 0;
}

.feature-group__upsell {
  display: block;
  width: 100%;
  border-radius: 14px;
  cursor: pointer;
}

.features-search-card {
  position: sticky;
  top: 0.75rem;
  padding: 1rem;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: #fff;
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.04);
}

.features-search-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.features-search-card__add {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(30, 30, 30, 0.12);
  border-radius: 10px;
  background: #fff;
  color: #424242;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  cursor: pointer;
}

.features-search-card__add:hover {
  border-color: #eb3d60;
  color: #eb3d60;
}

.features-search-card__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--ink);
}

.features-search-card__hint {
  margin: 0.3rem 0 0;
  color: var(--muted);
  font-size: 0.82rem;
}

.features-create-modal {
  padding: 0.25rem 0.15rem 0.5rem;
}

@media (max-width: 991.98px) {
  .features-studio__grid {
    grid-template-columns: 1fr;
  }

  .features-search-card {
    position: static;
  }
}
</style>
